module.exports = __webpack_public_path__ + "static/media/noclass16.1404dfad.png";